import React from 'react';

export function IconLinkedSource(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      fill="none"
      viewBox="0 0 120 120"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          fill="#D1811E"
          d="M6.186.994a3.53 3.53 0 0 0-4.935.568 3.47 3.47 0 0 0 .563 4.9L6.186.994Zm42.75 41.286c1.927-.221 3.31-1.952 3.09-3.866L48.44 7.234c-.22-1.914-1.961-3.286-3.888-3.064-1.928.222-3.311 1.953-3.091 3.866l3.188 27.716-27.916 3.212c-1.928.221-3.312 1.952-3.091 3.866.22 1.913 1.96 3.285 3.888 3.063l31.406-3.613ZM1.814 6.462l44.537 35.087 4.372-5.467L6.186.994 1.814 6.462Z"
        />
        <path
          stroke="#D1811E"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="7"
          d="M76.053 55.419a20.97 20.97 0 0 1 7.701 6.236 20.768 20.768 0 0 1 3.95 9.053 20.699 20.699 0 0 1-.687 9.841 20.819 20.819 0 0 1-5.167 8.427l-21 20.845A21.077 21.077 0 0 1 46 115.927a21.077 21.077 0 0 1-14.85-6.106A20.767 20.767 0 0 1 25 95.081c0-5.529 2.212-10.83 6.15-14.74l8.2-8.14m62.3-2.88 8.199-8.14A20.766 20.766 0 0 0 116 46.442c0-5.528-2.212-10.83-6.151-14.74A21.077 21.077 0 0 0 95 25.596 21.08 21.08 0 0 0 80.15 31.7l-21 20.846a20.82 20.82 0 0 0-5.167 8.426 20.7 20.7 0 0 0-.686 9.842 20.769 20.769 0 0 0 3.95 9.052 20.969 20.969 0 0 0 7.7 6.237"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h120v120H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
